import axios from "axios";
const {REACT_APP_CODE_BANQUE_API_URL,REACT_APP_CODE_GUICHET_API_URL} = process.env;

export class RibService {
    
    getCodeBanque(val) {
        return axios.get(REACT_APP_CODE_BANQUE_API_URL + "?codeBanque=" + val);
    }

    getCodeGuichet(val) {
        return axios.get(REACT_APP_CODE_GUICHET_API_URL + "?codeGuichet=" + val);
    }

    IsIbanCountryCodeValid = (value) => {
         const otherValue = value.substring(0, 2);
         if(otherValue === "FR" || otherValue === "MC"){
            return true;
         }
        return false;
   }

  /* static IsNomsEquivalentsTiretOuEspace (nom1, nom2){
        // Normalisation : majuscules, suppression accents, nettoyage caractères
        const normalize = (value) => value
          .toUpperCase()
          .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // accents
          .replace(/[^A-Z\s-]/g, "")                       // supprime tout sauf lettres, espaces et tirets
          .trim();

        // Convertit en tableau de mots (séparés par espaces ou tirets)
        const toWordSet = (value) => new Set(
          normalize(value).split(/[\s-]+/).filter(Boolean)
        );

        const mots1 = toWordSet(nom1);
        const mots2 = toWordSet(nom2);


        for (let mot of mots2) {
          if (!mots1.has(mot)) return false;
        }
        return true;
      };


  /* IsIbanTitulaireNomValid = (value, fiche) => {
         const valueFactored = value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[!#$%&'*+/=?^{|}~"(),:;<>[\]\\@\d<>*!«»“”]/g, "");

         if (
            (fiche.nom && valueFactored?.toLowerCase().includes(fiche.nom?.toLowerCase())) ||
            (fiche.nomNaissance && valueFactored?.toLowerCase().includes(fiche.nomNaissance?.toLowerCase())) ||
            (
              RibService.IsNomsEquivalentsTiretOuEspace(valueFactored, fiche.nom)
            ) ||
            (
              RibService.IsNomsEquivalentsTiretOuEspace(valueFactored, fiche.nomNaissance)
            )
          ) {
            return true;
         } else {
             return false;
         }
   }*/


   IsIbanTitulaireNomValid = (titulaire, fiche) => {
        const nomFamille=fiche?.nom ?? "";;
        const nomNaissance = fiche?.nomNaissance ?? "";
        if (!titulaire || (!nomFamille && !nomNaissance)) return false;

          // Normaliser les textes : majuscules et trim
            const normalize = (text = "") =>
              String(text)
                .toUpperCase()
                .replace(/[-./']/g, " ")
                .replace(/\s+/g, " ")
                .trim();

          const A = normalize(titulaire);
          const B = normalize(nomFamille);
          const C = normalize(nomNaissance);

          // Si le titulaire est "RIB ETRANGER", exclure du contrôle
          if (A === "RIB ETRANGER") return false;

          // Liste des mots à ignorer
          const motsExclus = ["M", "MR", "ML", "MLE", "MLLE", "ME", "MME"];

          // Découper les noms en mots et filtrer
          const motsFamille = B.split(" ").filter((mot) => mot && !motsExclus.includes(mot));
          const motsNaissance = C.split(" ").filter((mot) => mot && !motsExclus.includes(mot));

          // Vérifier la présence d'au moins un mot de B ou C dans A
          const correspondance =
            motsFamille.some((mot) => A.includes(mot)) ||
            motsNaissance.some((mot) => A.includes(mot));

          return correspondance;

   }




}
